module.exports = __webpack_public_path__ + "static/img/circle.03f78578.svg";